import { Component, OnInit } from '@angular/core';
import { TemplateService } from '../template-listing/template.service';
import moment from 'moment';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-call-performance',
  templateUrl: './call-performance.component.html',
  styleUrls: ['./call-performance.component.css']
})
export class CallPerformanceComponent implements OnInit {

  token: any
  storedData: any
  selectedDate:any;
  selectedMonth:any;
  reportType:any = 'daily';
  startDate:any;
  endDate:any;
  dailyData:any = []

  monthlyData:any = [];
  days:any = [];

  constructor(private templateService:TemplateService) { }

        ngOnInit(): void {

            this.token = localStorage.getItem('token');
            this.storedData = JSON.parse(localStorage.getItem("user") || '{}');
            let today:any = new Date();
            this.selectedDate = moment(today).format("YYYY-MM-DD")
            this.getcurrentMonthAndYear();
            this.generateReport();
        }

        generateReport(){
          
           if(this.reportType==='daily'){
              //  generate daily
              console.log(this.selectedDate)

              let date1:any = moment(this.selectedDate + " "+"00:00");
              let date2:any = moment(this.selectedDate + " "+"23:59");

              let req = {
                   "startDateTime": date1.utc().format(),
                   "endDateTime": date2.utc().format(),
              }

                this.templateService.generateReportDaily(this.token,req)
                .subscribe((response: any) => {
                  console.log(response)
                  if (response.status === 1) {
                      this.dailyData = response.data;
                  }
                });

           }else{
            //  generate monthly
             console.log(this.selectedMonth)
               let req = {
                   month:this.selectedMonth
              }

              

                this.templateService.generateReportMonthly(this.token,req)
                .subscribe((response: any) => {
                  console.log(response)
                  if (response.status === 1) {
                        this.monthlyData = response.data;
                           this.monthlyData.forEach((element:any) => {
                              element.total = 0;
                              this.days.forEach((e:any) => {
                                  

                                      const index1 = element.dailyStats.findIndex((obj:any) => obj.date === e);
                                        if(index1<0){
                                            element.dailyStats.push({
                                              "date": e,
                                              "totalCallTime": 0
                                            })

                                            
                                        }

                                        
                                      
                              });
                              console.log(this.days.length ,element.dailyStats.length )
                              if(this.days.length!=element.dailyStats.length){
                                 element.dailyStats.splice(element.dailyStats.length-1 , 1)
                              }

                              element.dailyStats.forEach((d:any) => {

                                  element.total = element.total + d.totalCallTime;
                              });
                      });

                  }
                });

              
           }
        }

        monthlyReport(info:any){
           this.reportType = info;
           this.getcurrentMonthAndYear();
           this.generateReport();
        }

        getcurrentMonthAndYear(){


          if(!this.selectedMonth){

            const now = new Date(this.selectedDate);
            let year:any = now.getFullYear();
            let month:any = String(now.getMonth() + 1).padStart(2, '0');
            this.selectedMonth = `${year}-${month}`; // e.g. "2025-10"
          

            const startDate = new Date(year, month - 1, 1);
            const endDate = new Date(year, month, 0); 

            this.startDate = moment(startDate).format("YYYY-MM-DD")
            this.endDate = moment(endDate).format("YYYY-MM-DD")
          }else{
              console.log(this.selectedMonth)    
          }

          this.onMonthChange();
            console.log(this.startDate , this.endDate)
        }


         minutesToHHMMSS(minutes: number): string {
          const totalSeconds = minutes;
          const hours = Math.floor(totalSeconds / 3600);
          const mins = Math.floor((totalSeconds % 3600) / 60);
          const secs = totalSeconds % 60;

          return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        }

        formatUTCTime(utcString: string): string {
          const date = new Date(utcString);
          const hours = date.getUTCHours().toString().padStart(2, '0');
          const minutes = date.getUTCMinutes().toString().padStart(2, '0');
          const seconds = date.getUTCSeconds().toString().padStart(2, '0');
          return `${hours}:${minutes}:${seconds}`;
        }

        onMonthChange() {
          this.days = []
          if (this.selectedMonth) {
            const [year, month] = this.selectedMonth.split('-').map(Number);
            const totalDays = new Date(year, month, 0).getDate(); // get number of days
            

            for (let i = 1; i <= totalDays; i++) {
              const day = i.toString().padStart(2, '0');
              this.days.push(`${year}-${month.toString().padStart(2, '0')}-${day}`);
            }

            console.log('Days:', this.days);
          }
        }

          copyText(text: string) {
              // navigator.clipboard.writeText(text);
              // alert(`Copied: ${text}`);
        
               navigator.clipboard.writeText(text).then(
                () => {
                    const Toast = Swal.mixin({
                          toast: true,
                          position: "center",
                          showConfirmButton: false,
                          timer: 1500,
                          timerProgressBar: true,
                          didOpen: (toast) => {
                            toast.onmouseenter = Swal.stopTimer;
                            toast.onmouseleave = Swal.resumeTimer;
                          }
                        });
                        Toast.fire({
                          icon: "success",
                          title: "Code copied to clipboard"
                        });
        
                },
                (err) => {
                  console.error('Could not copy text: ', err);
                }
              );
        }

}
